module.exports = __webpack_public_path__ + "assets/img/4.59c82c86.jpg";